<template>
    <span
        v-if="text"
        class="bsdc-tooltip"
    >
        <span>
            ?
        </span>
        <span
            v-if="text"
            v-text="text"
            data-tooltip-content
            class="bsdc:w-80 bsdc:p-4 bsdc:block bsdc:absolute bsdc:bottom-full bsdc:opacity-0 bsdc:pointer-events-none bsdc:shadow-xl bsdc:border bsdc:border-black/10 bsdc:bg-white bsdc:transition-opacity bsdc:ease-in-out bsdc:duration-300 bsdc:text-sm bsdc:font-normal bsdc:rounded-md"
        ></span>
    </span>
</template>

<script setup>
    defineProps({
        text: String,
    });
</script>

<style>
    @reference "../../css/app.css";

    .bsdc-tooltip {
        @apply bsdc:w-5 bsdc:h-5 bsdc:inline-flex bsdc:items-center bsdc:justify-center bsdc:relative bsdc:cursor-help bsdc:rounded-full bsdc:border bsdc:border-solid bsdc:border-1-2/20 bsdc:text-center bsdc:text-[13px] bsdc:font-bold bsdc:bg-white bsdc:z-20 bsdc:leading-none;
    }

    .bsdc-tooltip:hover [data-tooltip-content] {
        @apply bsdc:opacity-100;
    }

    @media (min-width: 451px) {
        .bsdc-tooltip [data-tooltip-content] {
            @apply bsdc:left-1/2 bsdc:transform bsdc:-translate-x-1/2 bsdc:-translate-y-2;

        }
    }

    @media (max-width: 450px) {
        .bsdc-tooltip [data-tooltip-content] {
            @apply bsdc:w-[270px] bsdc:left-0 bsdc:transform bsdc:-translate-x-[40px] bsdc:-translate-y-[8px];

        }
    }
</style>
